module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "static-info"
  }, [_c('sk-static-info-right-image', {
    attrs: {
      "static-title": _vm.title
    }
  }), _vm._v(" "), _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('hr')])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c9847b8","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/procurement-tabs/archive/archive.vue
// module id = 779
// module chunks = 0